import styled, { css } from 'styled-components';
// eslint-disable-next-line pocketlaw/no-px-units
export const visuallyHiddenStyles = css `
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  overflow-wrap: normal;
`;
export const Container = styled.span `
  ${visuallyHiddenStyles};
`;
